import { Autocomplete, Stack, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import { FormControl } from "@mui/material";
import { useState } from "react";
import { Option } from "../Utilities";
import config from "../config";

export default function SearchBar({ sourcePage, onSearch = null }) {
  let [keyword, setKeyword] = useState<string>("");
  let [contentTypeOptions, setContentTypeOptions] = useState<Option[]>([
    { label: "Show All", id: 0 },
    { label: config.contentType.Movie, id: config.contentTypeMapping.Movie },
    {
      label: config.contentType.Episode,
      id: config.contentTypeMapping.StandaloneEpisode,
    },
    { label: config.contentType.Season, id: config.contentTypeMapping.Season },
  ]);
  let [contentTypeSelected, setContentTypeSelected] = useState<Option | null>({
    label: "Show All",
    id: 0,
  });
  const searchRequest = () => {
    //controlla che almeno uno dei due filtri sia settato
    search();
  };

  function search() {
    const contentType =
      contentTypeSelected.id !== 0 ? contentTypeSelected.id : null;

    if (keyword === "") keyword = null;

    onSearch(keyword, contentType);
  }

  return (
    <div
      className="flex justify-center mt-4 p-2"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault(); // Prevent form submission on Enter key press
          searchRequest(); // Trigger the search when Enter is pressed
        }
      }}
    >
      <FormControl className="w-full ">
        <Stack spacing={2} direction="row" sx={{ marginBottom: 4 }}>
          <TextField
            id="keyword"
            type="text"
            variant="outlined"
            color="secondary"
            label="Search"
            onChange={(e) => setKeyword(e.target.value)}
            value={keyword}
            className="w-1/2"
          />

          <Autocomplete
            disablePortal
            disableClearable
            id="content-type"
            value={contentTypeSelected}
            options={contentTypeOptions}
            renderInput={(params) => (
              <TextField {...params} label="Content Type" />
            )}
            onChange={(event: any, newContentTypeSelected: Option) => {
              setContentTypeSelected(newContentTypeSelected);
            }}
            className="w-1/2"
          />
        </Stack>

        <div>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            onClick={searchRequest}
            className="float-right"
          >
            Search
          </Button>
        </div>
      </FormControl>
    </div>
  );
}
